module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-wrap"
  }, [_c('div', {
    staticClass: "cb-single-screen"
  }, [(_vm.one_screen_checkout) ? [_c('payment-section', {
    attrs: {
      "subscribe-mode": true
    }
  }, [(_vm.coupon_enabled && !_vm.is_discount_present) ? _c('div', {
    staticClass: "cb-section"
  }, [_c('cb-discount', {
    attrs: {
      "center-align": 'true'
    }
  })], 1) : _vm._e()])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-307d76f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/OneScreenReview.vue
// module id = 588
// module chunks = 66